// @flow

import React, { Component } from 'react';

import DialogMav from './DialogMav.jsx';

import type {T_DialogMavProps, T_DialogMavState} from './DialogMav.jsx';


export type T_PostMavProps = {
  zombie_props: T_DialogMavProps,
  zombie_state: T_DialogMavState
};



export default class PostMav extends Component<T_PostMavProps> {
  dialog_mav: ?DialogMav;
  
  
  componentDidMount() {
    if (this.dialog_mav != null) {
      this.dialog_mav.setState(this.props.zombie_state);
    }
  }
  
  
  
  render() {
    return (
      <DialogMav
        {...this.props.zombie_props}
        ref={comp => this.dialog_mav = comp}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/PostMav.jsx